import styled from "styled-components";
import { Link } from "react-router-dom";

export const FooterSection = styled("footer")`
  background: #ffffff;
  padding: 1.5rem 0;
  box-shadow: 0 -1px 0 0 rgba(0, 0, 0, 0.08);
`;

export const NavLink = styled(Link)`
  display: block;
  font-size: 1rem;
  color: #4e5d78;
  text-decoration: none;
  transition: all 0.2s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: #4f46e5;
  }
`;

export const LogoContainer = styled("div")`
  display: flex;
  align-items: center;

  img {
    width: auto;
    height: 64px;
    transform: scale(1.7);
    transform-origin: left center;

    @media only screen and (max-width: 768px) {
      height: 56px;
    }
  }
`;

export const FooterContainer = styled("div")`
  display: flex;
  align-items: center;
  gap: 2rem;

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    transition: all 0.2s ease-in-out;

    &:hover {
      transform: translateY(-2px);
    }
  }
`;

export const LinksContainer = styled("div")`
  display: flex;
  gap: 1.5rem;
`;
